import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
  AUTO_CAL_BALANCE_SHRINKAGE,
  GET_DT_BALANCE_ENERGY,
  GET_DT_BALANCE_ZONE_ENERGY,
  GET_DT_INVENTORY_ENERGY,
  GET_DT_INVENTORY_ZONE_ENERGY,
  GET_SHIPPER_BY_BOOKING,
  SAVE_DT_BALANCE_ENERGY,
  SAVE_DT_BALANCE_ZONE_ENERGY,
  SAVE_DT_INVENTORY_ENERGY,
  SAVE_DT_INVENTORY_ZONE_ENERGY,
} from "helpers/url_api_constant";
import { Col, Modal, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { Tab } from "bootstrap";
import TableMinInventory from "./TableMinInventory";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function BalancingEnergy(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);

  const [balanceShipper, setBalanceShipper] = useState([]);
  const [mergeData, setMergeData] = useState([]);
  const [dateSelect, setDateSelect] = useState(
    moment().add("days", -1).toDate()
  );
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "SHIPPER_NAME",
      text: "",
      headerAlign: "center",

      align: "center",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "12px",
        width: "40px",
      },
      style: { width: "40px" },
    },
  ]);
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const formatNumber = (cellContent, row) => {
    return <>{numberFormat(cellContent, 2)}</>;
  };

  const addHeaderTable = () => {
    $(`.inventoryenergy-table-header`).remove();

    let thead = document
      .getElementById(`inventoryenergy-table`)
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML = `<th class="inventoryenergy-table-header" colspan="1" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px;width:40px" ,">Shipper</th>`;
    props.column.map(row => {
      tr.innerHTML += `<th class="inventoryenergy-table-header" colspan="${props.zone.length}" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px">${row.BALANCECOLUMN_NAME}</th>`;
    });

    thead.prepend(tr);
  };

  //   const ButtonAction = (cellContent, row) => {
  //     return (
  //       <div>
  //         {permission.eBSG && (
  //           <>
  //             <button
  //               type="button"
  //               className="btn btn-secondary me-2"
  //               onClick={() => {}}
  //             >
  //               Refresh
  //             </button>
  //             <button
  //               type="button"
  //               className="btn btn-success me-2"
  //               onClick={() => {
  //                 handleSaveDataByRow(row);
  //               }}
  //             >
  //               Save
  //             </button>
  //           </>
  //         )}
  //       </div>
  //     );
  //   };

  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];

      // console.log(modelDeviceList)
      modelDeviceList.map(obj => {
        props.column.map(objColumn => {
          props.zone.map(objZone => {
            data.push({
              ...obj[
                `data_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                  ".",
                  "_"
                )
              ],
              INVENTORY_DATA:
                obj[
                  `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                    ".",
                    "_"
                  )
                ],
            });
          });
        });
      });
      // console.log(data)

      let res = await post(SAVE_DT_INVENTORY_ZONE_ENERGY, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        generateRow();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  //   const handleSaveDataByRow = async row => {
  //     dispatch(loadingAction.showLoading());
  //     try {
  //       let data = [];
  //     //   console.log(row);
  //       columnDataList.map(objColumn => {
  //         data.push({
  //           ...row[`${objColumn.BALANCECOLUMN_NAME.replaceAll(".", "_")}__data`],
  //           INVENTORY_DATA: row[objColumn.BALANCECOLUMN_NAME.replaceAll(".", "_")],
  //         });
  //       });
  //       //   console.log(row);
  //       let res = await post(SAVE_DT_INVENTORY_ENERGY, data);
  //       if (res.resultCode == 200) {
  //         dispatch(messageAction.showMessage("Save success."));
  //         // fetchData()
  //       } else {
  //         dispatch(messageAction.showMessage(res.resultDescription));
  //       }
  //     } catch (error) {
  //       dispatch(messageAction.showMessage(error.message));
  //     }
  //     dispatch(loadingAction.hideLoading());
  //   };
  const getBalanceShipperData = async () => {
    let shipper = await getBalanceShipper();
    let shipperList = [];
    shipper = shipper.data.shipperDataList;
    // console.log(shipper,sysShipper)
    shipper.map(row => {
      let mapShipper = props.shipper.find(
        obj =>
          obj.SHIPPER_NAME.trim().toLowerCase() ==
            row.SHOW_BOOING_VALUE.trim().toLowerCase() ||
          obj.CONTACT_CODE.trim().toLowerCase() ==
            row.SHIPPER_CODE.trim().toLowerCase()
      );
      if (mapShipper) shipperList.push(mapShipper);
    });
    setBalanceShipper(shipperList);
  };

  const manualRefresh = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(AUTO_CAL_BALANCE_SHRINKAGE, {
        // BALANCE_DATE: "01-01",
        BALANCE_DATE: moment(dateSelect).format("YYYY-MM-DD"),
        FLAG_AUTO_CAL: 0,
      });
      // console.log(res);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Refresh Success"));
        generateRow();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const generateRow = async () => {
    // console.log('test')
    dispatch(loadingAction.showLoading());
    try {
      let [INVENTORY_ENERGY, INVENTORY_ZONE_ENERGY, INVENTORY_ENERGY_ALL] =
        await Promise.all([
          post(GET_DT_INVENTORY_ENERGY, {
            INVENTORY_DATE: moment(dateSelect).format("YYYY-MM-DD"),
          }),
          post(GET_DT_INVENTORY_ZONE_ENERGY, {
            START_DATE: moment(props.dateSelected)
              .startOf("month")
              .format("YYYY-MM-DD"),
            END_DATE: moment(props.dateSelected)
              .endOf("month")
              .format("YYYY-MM-DD"),
          }),
          post(GET_DT_INVENTORY_ENERGY, {
            INVENTORY_DATE: moment(props.dateSelected)
              .startOf("month")
              .format("YYYY-MM-DD"),
            INVENTORY_TO_DATE: moment(props.dateSelected)
              .endOf("month")
              .format("YYYY-MM-DD"),
          }),
        ]);
      // console.log(INVENTORY_ENERGY)
      // console.log(INVENTORY_ZONE_ENERGY)
      // console.log(INVENTORY_ENERGY_ALL)

      let mapData = INVENTORY_ZONE_ENERGY.data.DtInventoryZoneList.map(
        objZoneEnergy => {
          let obj = INVENTORY_ENERGY_ALL.data.DtInventoryEnergyList.find(
            objBalanceEnergy =>
              objBalanceEnergy.PID == objZoneEnergy.INVENTORYENERGY_PID
          );
          //  console.log(obj)
          if (obj) {
            objZoneEnergy.INVENTORYSHIPPER_PID = obj.INVENTORYSHIPPER_PID;
            // objZoneEnergy.BALANCECOLUMN_PID = obj.BALANCECOLUMN_PID;
            objZoneEnergy.INVENTORY_DAY = obj.INVENTORY_DAY;
          }
          // console.log(objZoneEnergy)
          return objZoneEnergy;
        }
      );
      // console.log(mapData);
      setMergeData(mapData);

      let tempBalaneEnergy = [];
      let tempDataList = [];
      let date = moment(dateSelect);
      // console.log(createdBalaneEnergy)
      // console.log(INVENTORY_ENERGY.data.DtInventoryEnergyList)
      balanceShipper.map((objShipper, index) => {
        //   console.log(objShipper)
        let data = { row: index, SHIPPER_NAME: objShipper.SHIPPER_NAME };
        // console.log(data)
        // console.log(INVENTORY_ENERGY.data.DtInventoryEnergyList);
        props.column.map(objColumn => {
          let createdBalaneEnergy =
            INVENTORY_ENERGY.data.DtInventoryEnergyList.find(
              row =>
                row.INVENTORYSHIPPER_PID == objShipper.PID &&
                //   row.BALANCECOLUMN_PID == objColumn.PID &&
                row.INVENTORY_DAY == date.format("D")
            );
          //   console.log(createdBalaneEnergy);
          // console.log(`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_"))
          data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")] = {
            PID: "",
            INVENTORY_DATE: date.format("YYYY-MM-DD"),
            INVENTORYSHIPPER_PID: objShipper.PID,
            // BALANCECOLUMN_PID: objColumn.PID,
            // BALANCECOLUMN_ORDER: objColumn.BALANCECOLUMN_ORDER,
            INVENTORYCOLUMN_NAME: objColumn.BALANCECOLUMN_NAME,
            INVENTORY_DAY: date.format("D"),
            ...createdBalaneEnergy,
          };
          //   console.log(
          //     data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")]
          //   );
          tempBalaneEnergy.push(
            data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")]
          );
          // tempBalaneEnergy
          // console.log(props.zone)
          // console.log(INVENTORY_ZONE_ENERGY.data.DtInventoryZoneList)
          props.zone.map(objZone => {
            // console.log(createdBalaneEnergy, BALANCE_ZONE_ENERGY.data.dtBalanceList)
            let createdBalaneZoneEnergy =
              INVENTORY_ZONE_ENERGY.data.DtInventoryZoneList.find(
                row =>
                  row.INVENTORYZONE_PID == objZone.PID &&
                  row.INVENTORYENERGY_PID ==
                    (createdBalaneEnergy ? createdBalaneEnergy.PID : false)
              );
            // console.log(createdBalaneZoneEnergy)

            // console.log(createdBalaneEnergy)
            data[
              `data_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                ".",
                "_"
              )
            ] = {
              INVENTORYENERGY_PID: createdBalaneEnergy
                ? createdBalaneEnergy.PID
                : "",
              INVENTORY_DATE: date.format("YYYY-MM-DD"),
              INVENTORYSHIPPER_PID: objShipper.PID,
              //   BALANCECOLUMN_PID: objColumn.PID,
              //   BALANCECOLUMN_ORDER: objColumn.BALANCECOLUMN_ORDER,
              INVENTORYCOLUMN_NAME: objColumn.BALANCECOLUMN_NAME,
              INVENTORY_DAY: date.format("D"),
              PID: "",
              INVENTORYZONE_PID: objZone.PID,
              INVENTORYZONE_ORDER: objZone.BALANCEZONE_ORDER,
              INVENTORYZONE_NAME: objZone.BALANCEZONE_ALIAS,
              INVENTORY_DATA: "",
              ...createdBalaneZoneEnergy,
            };

            data[
              `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                ".",
                "_"
              )
            ] = createdBalaneZoneEnergy
              ? createdBalaneZoneEnergy.INVENTORY_DATA
              : 0;
          });
        });
        // console.log(data)
        tempDataList.push(data);
      });
      //   console.log(tempBalaneEnergy);
      tempBalaneEnergy = tempBalaneEnergy.filter(row => row.PID == "");
      // console.log(tempBalaneEnergy)
      if (tempBalaneEnergy.length > 0) {
        if(permission.eBSG ){
        let res = await post(SAVE_DT_INVENTORY_ENERGY, tempBalaneEnergy);
        generateRow();
        }
      }
      // console.log(tempDataList)
      setModelDeviceList(tempDataList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
    // console.log(dataList)
  };

  // useEffect(() => {
  //  if(balaneEnergy.length>0 ||balaneZoneEnergy.length>0){
  //    console.log(1)
  //   generateRow();
  //  }

  // }, [balaneEnergy]);
  const getBalanceShipper = () =>
    post(GET_SHIPPER_BY_BOOKING, {
      LOAD_DATE: moment(dateSelect).format("YYYY-MM-DD"),
    });
  useEffect(() => {
    moment(props.dateSelected).isSame(new Date(), "month")
      ? setDateSelect(moment().add("days", -1).toDate())
      : setDateSelect(moment(props.dateSelected).endOf("month").toDate());
    // setDateSelect()
    addHeaderTable();
  }, [props.dateSelected]);
  useEffect(() => {
    getBalanceShipperData();
  }, [dateSelect]);
  useEffect(() => {
    renderColumn();
  }, [props.zone, props.column]);
  useEffect(() => {
    generateRow();
    // console.log(balanceShipper);
  }, [balanceShipper]);
  useEffect(() => {
    addHeaderTable();
    if (columnRenderList.length > 1) {
      // console.log(2)
      getBalanceShipperData();
    }
  }, [columnRenderList]);
  const renderColumn = () => {
    let addColumn = [
      ...props.column
        .sort((a, b) =>
          a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
            ? 1
            : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
            ? -1
            : 0
        )
        .filter(
          obj =>
            obj.BALANCECOLUMN_SHOW == true || obj.BALANCECOLUMN_SHOW == "true"
        )
        .map(objColumn => {
          return props.zone
            .sort((a, b) =>
              a.BALANCEZONE_ORDER > b.BALANCEZONE_ORDER
                ? 1
                : b.BALANCEZONE_ORDER > a.BALANCEZONE_ORDER
                ? -1
                : 0
            )
            .map(objZone => ({
              dataField:
                `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                  ".",
                  "_"
                ),
              formatter: formatNumber,
              text: objZone.BALANCEZONE_ALIAS,
              headerAlign: "center",
              editable: true,
              align: "center",
              headerStyle: {
                backgroundColor: colorOption[2].label,
                fontSize: "10px",
                width: "20px",
              },
              style: { width: "25px", cursor: "pointer" },
              editorStyle: () => {
                return { height: "25px" };
              },
              classes: (cell, row, rowIndex, colIndex) => {
                let className = "";
                if (objColumn.STATUS_FLAG != 0) className += "from-source";
                if (objColumn.STATUS_FLAG == 1) className += " pmis";
                if (objColumn.STATUS_FLAG == 3) className += " gqms";
                return className;
              },
              validator: (newValue, row, column, done) => {
                setTimeout(() => {
                  if (isNaN(newValue)) {
                    return done({
                      valid: false,
                      message: "Should be numeric",
                    });
                  }
                  return done();
                }, 0);
                return {
                  async: true,
                };
              },
            }));
        }),
    ];
    let data = [];
    addColumn.map(array => {
      array.map(obj => data.push(obj));
    });
    // console.log(data)
    setColumnRenderList([
      {
        dataField: "SHIPPER_NAME",
        text: "",
        headerAlign: "center",

        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          fontSize: "12px",
          width: "20px",
        },
        style: { width: "20px" },
      },
      ...data,
      //   {
      //     dataField: "Action",
      //     text: "Action",
      //     headerAlign: "center",
      //     editable: false,
      //     align: "center",
      //     headerStyle: {
      //       backgroundColor: "#556ee6",
      //       width: "10%"
      //     },
      //     style: { width: "10%" },
      //     isDummyField: true,
      //     formatter: ButtonAction,
      //   },
    ]);
  };

  return (
    <>
      <Col sm="12">
        <div className="d-flex justify-content-end mb-2">
          <h5>Min Inventory (Energy)</h5>
        </div>
        <div>
          <Row>
            <Col sm="5">
              <div style={{ width: "150px" }}>
                <Flatpickr
                  className="form-control d-block custom-date-picker"
                  placeholder="Select Date"
                  options={{
                    altInput: true,
                    altFormat: "d/m/Y",
                    // altFormat: "F Y",
                    dateFormat: "d/m/Y",
                    maxDate: moment(props.dateSelected).isSame(
                      new Date(),
                      "month"
                    )
                      ? moment().add("days", -1).toDate()
                      : moment(props.dateSelected).endOf("month").toDate(),
                    minDate: moment(props.dateSelected)
                      .startOf("month")
                      .toDate(),
                  }}
                  onChange={value => {
                    setDateSelect(value[0]);
                  }}
                  value={dateSelect}
                />
              </div>
            </Col>
            <Col
              sm="7"
              className="d-flex align-items-center justify-content-end"
            >
              {permission.eBSG && (
                <>
                  {/* <button
                    type="button"
                    className="btn btn-info"
                    
                    onClick={() => {
                      dispatch(
                        confirmAction.showConfirm(
                          "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                          () => {
                            manualRefresh();
                          }
                        )
                      );
                    }}
                  >
                    <i className="mdi mdi-cloud-refresh fa-lg"></i>&nbsp;
                    Refresh Manual
                  </button> */}

                  <button
                    type="button"
                    className="btn btn-success ms-2"
                    onClick={handleSaveData}
                  >
                    <i className="bx bx-save"></i>&nbsp; Save
                  </button>
                </>
              )}
            </Col>
          </Row>
        </div>

        <>
          <div className="mt-2">
            <Col sm="6">
              <BootstrapTable
                id="inventoryenergy-table"
                keyField="SHIPPER_NAME"
                data={modelDeviceList}
                columns={columnRenderList}
                headerClasses="header-style"
                rowStyle={rowStyle}
                cellEdit={cellEditFactory({
                  mode: "click",
                  blurToSave: true,
                  onStartEdit: (oldValue, newValue, row, column) => {
                    $(
                      "#inventoryenergy-table .form-control.editor.edit-text"
                    ).bind("enterKey", function (e) {
                      let cell = $(this).parent().next();
                      setTimeout(() => {
                        cell.click();
                      }, 50);
                    });
                    $(
                      "#inventoryenergy-table .form-control.editor.edit-text"
                    ).keypress(function (e) {
                      if (e.keyCode == 13) {
                        $(this).trigger("enterKey");
                      }
                    });
                  },
                  afterSaveCell: (oldValue, newValue, row, column) => {
                    // console.log(oldValue,newValue, row, column)
                  },
                })}
              />
            </Col>
          </div>

          <hr />
        </>
      </Col>

      {balanceShipper.map(item => (
        <TableMinInventory
          key={item.PID}
          data={mergeData.filter(row => row.INVENTORYSHIPPER_PID == item.PID)}
          dateSelected={props.dateSelected}
          column={props.column}
          zone={props.zone}
          shipper={item}
        />
      ))}
    </>
  );
}
const rowStyle = (row, rowIndex) => {
  const style = {};

  style.color = "white";

  return style;
};

export default BalancingEnergy;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

BalancingEnergy.propTypes = {
  dateSelected: PropTypes.any,
  column: PropTypes.any,
  zone: PropTypes.any,
  shipper: PropTypes.any,
};
